import React from 'react';
import { dateFormatter, numberFormatter } from '../common/formatter';
import ReportDescription from './ReportDescription';

const BudgetOverview = ({budget, allocatedBudget, publishedBudget}) => {
    const {formatAsAbbrDate, convertDateFromUTCToLocal} = dateFormatter;
    const getLongDate = (dateAsString) => formatAsAbbrDate(convertDateFromUTCToLocal(new Date(dateAsString)));
    if(!budget) return null;
    return (
            <div className='budget-overview'>
                <h3 className='font-secondary font-weight-500 font-size-18 text-color-dark'>Overview</h3>
                <div className='budget-overview-container'>
                <ReportDescription header={`${budget.name}`}
                    content={(
                    <span>{numberFormatter.formatAsCurrency(budget.amount, 0)}</span>)}
                    footer={<span>{getLongDate(budget.startDate)} - {getLongDate(budget.endDate)}</span>} />

                    <BudgetRemainder title={'Total Allocated'} totalAllocation={budget.amount} currentAllocated={allocatedBudget}/>
                    <BudgetRemainder title={'Total Published'} totalAllocation={budget.amount} currentAllocated={publishedBudget} />

                </div>
            </div>
        );

};

export default BudgetOverview;


export const BudgetRemainder = ({title, totalAllocation, currentAllocated}) => {
    const percent = currentAllocated.publications_budget/totalAllocation;
    const progressValue = numberFormatter.formatShortCurrency(currentAllocated.publications_budget);
    const percentValue = percent < 1 ? percent*100 : 100;
    const percentValueReducer = percent >= 0.2 ? 7.5 : 0;
    return (
       <div className='budget-remainder-wrapper'>
           <h4 className='font-secondary'>{title}</h4>
           <span className='budget no-margin font-secondary font-size-24 text-color-dark'>{numberFormatter.formatAsPercentage(percent, 0)}</span>
           <span className='ml-10'>{currentAllocated.total_publications} videos</span>
            <div className='budget-progress-container'>
                <div className='budget-progress-bar'>
                    <div style={{width: `${percentValue}%`}}></div>
                </div>
                <span className='text-color-dark' style={{marginLeft: `${percentValue - percentValueReducer}%`}}>{progressValue}</span>
            </div>
        </div>
    );
};
